import { fetchingAPI, apiService } from '@/api'

import {
  addEmailIngestionBlocklistEntry,
  removeEmailIngestionBlocklistEntry,
  setEmailIngestionBlocklist,
  setEmailIngestionBlocklistLoading,
} from './emailIngestionBlocklist.redux'

const baseUrl = (organizationId) =>
  `${apiService.core}/api/organizations/${organizationId}/email-ingestion-blocklist`

export const fetchEmailIngestionBlocklist =
  ({ organizationId }) =>
  async (dispatch) => {
    dispatch(setEmailIngestionBlocklistLoading(true))
    try {
      const entries = await fetchingAPI(baseUrl(organizationId), 'GET', dispatch)
      const safeEntries = entries || []
      dispatch(setEmailIngestionBlocklist(safeEntries))
      return safeEntries
    } finally {
      dispatch(setEmailIngestionBlocklistLoading(false))
    }
  }

export const createEmailIngestionBlocklistEntry =
  ({ organizationId, entryType, value }) =>
  async (dispatch) => {
    const entry = await fetchingAPI(
      baseUrl(organizationId),
      'POST',
      dispatch,
      JSON.stringify({ entry_type: entryType, value })
    )
    if (entry) {
      dispatch(addEmailIngestionBlocklistEntry(entry))
    }
    return entry
  }

export const deleteEmailIngestionBlocklistEntry =
  ({ organizationId, entryId }) =>
  async (dispatch) => {
    await fetchingAPI(`${baseUrl(organizationId)}/${entryId}`, 'DELETE', dispatch)
    dispatch(removeEmailIngestionBlocklistEntry(entryId))
  }
